<template>
  <div>
    <br />
    <b-row>
      <b-col cols="2">
        <b-form-group label="ID Original">
          <b-form-input type="text" size="sm" placeholder="ID Original" v-model="form.channel_id">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Demais ID">
          <b-form-input type="text" size="sm" placeholder="Demais ID" v-model="form.external">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Número ou Chave da Nota">
          <b-form-input type="text" size="sm" placeholder="Número ou Chave da Nota" v-model="form.nfe_number_or_key">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Canal">
          <b-form-select size="sm" :options="oprtions_available_channels" v-model="form.created_by">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="PluggID">
          <b-form-input type="text" size="sm" placeholder="Plugg ID" v-model="form.id">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col v-show="!faCaret" cols="2" class="text-center" style="margin-top: 27px">
        <b-button size="sm" variant="success" @click="filter()"> Buscar </b-button>
        <b-button size="sm" variant="light" @click="filterClear"> Limpar </b-button>
      </b-col>
      <b-col v-show="faCaret" cols="2">
        <b-form-group label="SKU">
          <b-form-input type="text" size="sm" placeholder="SKU" v-model="form.sku">
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-show="faCaret">
      <b-col cols="2">
        <b-form-group label="Possui status">
          <b-form-select size="sm" v-model="form.status" :options="options_status" multiple class="pb-140">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Não possui status">
          <b-form-select size="sm" v-model="not_status" :options="options_status" @change="notStatusF()" multiple class="pb-140">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="SLA's">
          <b-form-select size="sm" v-model="form.sla" :options="options_slas">
          </b-form-select>
        </b-form-group>
        <b-form-group label="Nome do cliente">
          <b-form-input type="text" size="sm" placeholder="Primeiro nome" v-model="form.payer_name">
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Por conta">
          <b-form-select size="sm" v-model="form.channel_account" :options="options_por_conta">
          </b-form-select>
        </b-form-group>
        <b-form-group label="Sobrenome do cliente">
          <b-form-input type="text" size="sm" placeholder="Sobrenome" v-model="form.payer_lastname"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Tipo de entrega">
          <b-form-select size="sm" v-model="form.delivery_type" :options="options_tipo_entrega">
          </b-form-select>
        </b-form-group>
        <b-form-group label="Tipos de etiquetas">
          <b-form-select size="sm" v-model="form.label_type" :options="options_tipo_etiqueta">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Tipos de Pagamentos">
          <b-form-select size="sm" v-model="form.payment_type" :options="options_payment_type">
          </b-form-select>
        </b-form-group>
        <b-form-group label="Data">
          <b-form inline>
            <b-form-input type="datetime-local" size="sm" v-model="form.datestart"></b-form-input>
            <b-form-input type="datetime-local" size="sm" v-model="form.dateend" class="mt-3"></b-form-input>
          </b-form>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-show="faCaret">
      <b-col class="text-right" style="margin-top: 27px">
        <b-button size="sm" variant="success" @click="filter()" :disabled="desables_filter">
          Buscar
        </b-button>
        <b-button size="sm" variant="light" @click="filterClear()"> Limpar </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <b-button size="sm" variant="light" @click="faCaret = !faCaret">
          <i :class="faCaret ? 'fas fa-caret-up' : 'fas fa-caret-down'"></i>
          {{ faCaret ? "Minimizar os filtros" : "Mostrar todos os filtros" }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import barramento from "../../../barramento";
export default {
  props: ["expedition", "options_por_conta", "oprtions_available_channels"],
  data() {
    return {
      faCaret: false,
      not_status: [],
      form: {
        id: null,
        sku: null,
        sla: null,
        label: null,
        status: [],
        p_open: true,
        dateend: null,
        nfe_number_or_key: null,
        external: null,
        sub_status: null,
        created_by: null,
        channel_id: null,
        label_type: null,
        payment_type: null,
        datestart: null,
        payer_name: null,
        delivery_type: null,
        payer_lastname: null,
        has_invoice_pdf: null,
        channel_account: null,
      },
      desables_filter: false,
      options_status: [
        { value: "pending", text: "Pendente" },
        { value: "paid", text: "Pago" },
        { value: "approved", text: "Aprovado" },
        { value: "partial_payment", text: "Pagamento parcial" },
        { value: "shipping_informed", text: "Entrega informada" },
        { value: "waiting_invoice", text: "Nota fiscal solicitada" },
        { value: "picking", text: "Em separação" },
        { value: "invoiced", text: "Faturado" },
        { value: "invoice_error", text: "Erro ao gerar nota fiscal" },
        { value: "shipped", text: "Em Trânsito" },
        { value: "shipping_error", text: "Erro ao enviar entrega" },
        { value: "delivered", text: "Entregue" },
        { value: "canceled", text: "Cancelado" },
        { value: "under_review", text: "Sob análise" },
        { value: "requested_dispute", text: "Disputa aberta" },
        { value: "processing_dispute", text: "Disputa em andamento" },
        { value: "finished_dispute", text: "Disputa finalizada" },
      ],
      options_slas: [
        { value: null, text: "Selecione o sla" },
        { value: "expiredSendSla", text: "Envio expirado" },
        { value: "expiredDeliverySla", text: "Entrega expirada" },
        { value: "sendToday", text: "Enviar Hoje" },
      ],
      options_tipo_entrega: [
        { value: null, text: "Selecione o tipo de entrega" },
        { value: "standard", text: "Padrão" },
        { value: "express", text: "Expressa" },
        { value: "onehour", text: "Motoboy" },
        { value: "pickup", text: "Retirada" },
        { value: "economy", text: "Econômica" },
        { value: "guaranteed", text: "Garantida" },
        { value: "scheduled", text: "Agendada" },
        { value: "fastshipping", text: "Coleta Rápida" },
        { value: "international", text: "Internacional" },
        { value: "fulfillment", text: "Fulfillment" },
      ],
      options_tipo_etiqueta: [
        { value: null, text: "Selecione o tipo" },
        { value: "manual", text: "Manual" },
        { value: "third_contract", text: "Etiqueta do MarketPlace" },
        { value: "fulfillment", text: "Fulfillment" },
        { value: "own_contract", text: "Contrato Próprio" },
        { value: "pickup_store", text: "Retirada" },
        { value: "drop_shipping", text: "Envio pelo Fornecedor" },
        { value: "without_label", text: "Sem Etiqueta" }
      ],
      options_payment_type: [
        { value: null, text: "Selecione o tipo" },
        { value: "credit", text: "Cartão de Crédito" },
        { value: "debit", text: "Cartão de Débito" },
        { value: "ticket", text: "Boleto" },
        { value: "voucher", text: "Conta" },
        { value: "transfer", text: "PIX" },
      ]
    };
  },
  beforeDestroy() {
    barramento.$off(`loading_filters_${this.expedition.expedition}`);
  },
  created() {
    barramento.$on(`loading_filters_${this.expedition.expedition}`, () => {
      this.filter();
    });
  },
  methods: {
    filter() {
      this.desables_filter = true;

      if (!this.form.status.length && !!this.expedition.filters.status)
        this.form.status.push(this.expedition.filters.status);

      if (!this.form.sub_status)
        this.form.sub_status = this.expedition.filters.sub_status;

      let newObj = {};
      let object = this.form;
      Object.keys(object).forEach((prop) => {
        if (object[prop])
          if (object[prop].length || object[prop] === true || object[prop] === false)
            newObj[prop] = object[prop];
      });

      //newObj['integrated'] = this.expedition.expedition === "integracao_incorreta" ? 0 : 1;
      if (this.expedition.expedition !== "integracao_incorreta")
        newObj['integrated'] = 1;

      barramento.$emit("orders_filters", newObj);
      barramento.$emit(this.expedition.expedition, newObj);

      setTimeout(() => {
        this.desables_filter = false;
      }, 1000);
    },
    filterClear() {
      this.label = null;
      this.form.id = null;
      this.form.sku = null;
      this.form.sla = null;
      this.form.dateend = null;
      this.form.nfe_number_or_key = null;
      this.form.external = null;
      this.form.datestart = null;
      this.form.payer_name = null;
      this.form.label_type = null;
      this.form.payment_type = null;
      this.has_invoice_pdf = null;
      this.form.created_by = null;
      this.form.channel_id = null;
      this.form.not_status = [];
      this.form.delivery_type = null;
      this.form.payer_lastname = null;
      this.form.channel_account = null;

      this.form.status = [];
      if (this.expedition.filters.status)
        this.form.status.push(this.expedition.filters.status);

      this.form.sub_status = this.expedition.filters.sub_status;

      if (this.expedition.expedition === "integracao_incorreta") {
        this.form.status = [];
        this.form.sub_status = null;
      }
      barramento.$emit(this.expedition.expedition, null);
    },
    notStatusF() {
      this.form.status = [];
      for (var j in this.options_status) {
        if (!this.not_status.find(fruit => fruit === this.options_status[j].value)) {
          this.form.status.push(this.options_status[j].value);
        }
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Orders_v2/Aggregates/Filter.vue